export default "__VITE_ASSET__8yYkSiQD__"